<template>
  <accommodation-category-form />
</template>

<script>
import AccommodationCategoryForm from '@/components/forms/AccommodationCategoryForm'
export default {
  components: {
    AccommodationCategoryForm
  }
}
</script>
